import $ from 'jquery';

function playVideo() {
    const videoContainers = document.querySelectorAll(
        '.js-video-with-thumbnail'
    );

    if (!videoContainers.length) {
        return;
    }

    videoContainers.forEach(videoContainer => {
        const videoPlayButton = videoContainer.querySelector(
            '.js-video-play-button'
        );
        const videoThumbnail = videoContainer.querySelector(
            '.js-video-thumbnail'
        );
        const video = videoContainer.querySelector('.js-video');
        const iframe = videoContainer.querySelector('iframe');

        if (!videoPlayButton || !videoThumbnail || !video || !iframe) {
            return;
        }

        function buildUrl(
            originalUrl,
            isAutoplay,
            isControls,
            isRel,
            isLoop,
            isModestBranding,
            isEnableJsApi
        ) {
            var uri = new URL(originalUrl);

            if (!uri) {
                return '';
            }

            let newUrl = uri.origin + uri.pathname;

            let searchParams = uri.searchParams;

            searchParams.set(
                'autoplay',
                isAutoplay === true
                    ? '1'
                    : isAutoplay === false
                        ? '0'
                        : searchParams.get('autoplay')
            );

            searchParams.set(
                'controls',
                isControls === true
                    ? '1'
                    : isControls === false
                        ? '0'
                        : searchParams.get('controls')
            );

            searchParams.set(
                'rel',
                isRel === true
                    ? '1'
                    : isRel === false
                        ? '0'
                        : searchParams.get('rel')
            );

            searchParams.set(
                'loop',
                isLoop === true
                    ? '1'
                    : isLoop === false
                        ? '0'
                        : searchParams.get('loop')
            );

            searchParams.set(
                'modestbranding',
                isModestBranding === true
                    ? '1'
                    : isModestBranding === false
                        ? '0'
                        : searchParams.get('modestbranding')
            );

            searchParams.set(
                'enablejsapi',
                isEnableJsApi === true
                    ? '1'
                    : isEnableJsApi === false
                        ? '0'
                        : searchParams.get('enablejsapi')
            );

            return newUrl + '?' + searchParams.toString();
        }

        //const videoSrc = video.dataset.src;

        videoPlayButton.addEventListener('click', () => {
            //video.setAttribute('src', videoSrc);

            video.classList.remove('is-hidden');

            let isModestBranding = video.dataset.modestbranding === '1';
            let isAutoplay = video.dataset.autoplay === '1';
            let isControls = video.dataset.controls === '1';
            let isRel = video.dataset.controls === '1';
            let isLoop = video.dataset.loop === '1';

            let iframeSrc = iframe.src;

            iframe.src = buildUrl(
                iframeSrc,
                isAutoplay,
                isControls,
                isRel,
                isLoop,
                isModestBranding,
                null
            );

            setTimeout(() => {
                videoThumbnail.classList.add('is-hidden');
            }, 200);
        });
    });
}

// Kick off the init on document ready
$(() => {
    playVideo();
});
